import { QueryClient, QueryKey } from "@tanstack/react-query";

export const enum QueryModule {
   Subscriptions = "SubscriptionsQueries",
   ContinuousLearningSync = "ContinuousLearningSyncQueries",
   AppSettings = "AppSettingsQueries",
   Profile = "ProfileQueries",
   Sse = "SseQueries",
   Watchlist = "WatchlistQueries",
   LiveShows = "LiveShowsQueries",
   GuestProfile = "GuestProfileQueries",
   Portfolio = "PortfolioQueries",
   CeoVsEmployee = "CeoVsEmployeeQueries",
   Loyalty = "LoyaltyQueries",
   Projects = "ProjectsQueries",
   Healthcheck = "HealthcheckQueries",
   Onboarding = "OnboardingQueries",
   Wallet = "WalletQueries",
   Notifications = "NotificationsQueries",
   WorthData = "WorthDataQueries",
   User = "UserQueries",
   Endorsements = "EndorsementsQueries",
   PublicProfile = "PublicProfileQueries",
   ProfileAnalytics = "ProfileAnalyticsQueries",
   PublicProjects = "PublicProjectsQueries",
   Plaid = "PlaidQueries",
   Startups = "StartupsQueries",
   BugReport = "BugReportQueries",
   ProfileDemo = "ProfileDemoQueries",
}

export interface InvalidateQueryOptions {
  invalidateCurrentModule?: boolean;
  invalidateModules?: QueryModule[];
  invalidateKeys?: QueryKey[];
}

export async function invalidateQueries(
  queryClient: QueryClient,
  currentModule: QueryModule,
  options: InvalidateQueryOptions = {},
) {
  const { invalidateCurrentModule, invalidateModules, invalidateKeys } = options;

  if (invalidateCurrentModule) {
    await queryClient.invalidateQueries({ queryKey: [currentModule] });
  }

  if (invalidateModules) {
    await Promise.all([...invalidateModules.map((module) => queryClient.invalidateQueries({ queryKey: [module] }))]);
  }

  if (invalidateKeys) {
    await Promise.all([...invalidateKeys.map((queryKey) => queryClient.invalidateQueries({ queryKey }))]);
  }
}

